import '@sparta.global.utilities/sparta-breakout-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-global-functions-utility/dist/es6.js';
import '@sparta.global.utilities/sparta-store-utility/dist/es6.js';
import spartaTabDropdownUtility from '@sparta.global.utilities/sparta-tab-dropdown-utility/dist/es6.js';
import spartaTabNavUtility from '@sparta.global.utilities/sparta-tab-nav-utility/dist/es6.js';

/**
 * Namespace for the Sparta Tab Utility.
 * @constant {string}
 */
const utilityNamespace = 'spartaTabUtility';

/**
 * Configures inputs for validation, formatting, obfuscation, etc.
 */
class SpartaTabUtility {
  /**
   * Initializes a new instance of the `SpartaTabUtility` class.
   * @param {object} [options] - Optional object for configuring overrides.
   * @returns {void}
   */
  init(options = {}) {
    const setOptions = options;
    setOptions.utilitySource = utilityNamespace;
    spartaTabNavUtility.init(setOptions);
  } // END init

  /**
   * Loads dynamic content into DOM. Content may be brought in via promise or direct DOM injection.
   * @param {object} settings - Settings to pass to `spartaTabDropdownUtility`.
   * @param {object} tab - tab DOM element passed to `spartaTabDropdownUtility`.
   * @param {object} panel - panel DOM element passed to `spartaTabDropdownUtility`.
   * @param {object|string} safeString - The markup to pass to `spartaTabDropdownUtility`.
   * @param {object} spartaTabNavUtility - Pass functions to to `spartaTabDropdownUtility`.
   * @returns {void}
   */
  loadContent(settings, tab, panel, safeString) {
    spartaTabDropdownUtility.dropdownLoadContent(settings, tab, panel, safeString, spartaTabNavUtility);
  }

  /**
   * Loads dynamic content into DOM. Content may be brought in via promise or direct DOM injection.
   * @param {object} elementID - ID of element to pass to `spartaTabNavUtility`.
   * @returns {void}
   */
  openPanel(elementID) {
    spartaTabNavUtility.openPanel(elementID);
  }
}

// Export new instance of the Sparta Tab Utility.
var index = new SpartaTabUtility();

export { index as default };
